import React from "react";
import {connect} from "react-redux";
import BsForm from "components/form/BsForm";
import BsFormPanel from "components/form/BsFormPanel";
import ConfirmationModel from "components/model/ConfirmationModel";
import {deleteLabelAdmin, loadLabelAdmin} from "core/actions/label-actions";
import LabelAdminInfoActions from "./LabelAdminInfoActions";
import LABEL_ADMIN_INFO_FORM from "./label-admin-form";

class GlobalLabelAdminInfo extends React.Component {

  constructor(props) {
    super(props);
    this.formRef = React.createRef();
    this.state = {
      backUrl: '/global/label/' + this.props.match.params.labelId + '/admins',
      openConfirmationWindow: false
    };
    this.props.loadLabelAdmin(this.props.match.params.labelId, this.props.match.params.userId);
  }

  onHandleDelete() {
    this.setState({openConfirmationWindow: true})
  }

  onDelete() {
    this.props.deleteLabelAdmin(this.props.match.params.labelId, this.props.match.params.userId);
    this.setState({openConfirmationWindow: false})
  }

  render() {
    if (this.props.currentAdmin) {
      const formConfig = {
        ...LABEL_ADMIN_INFO_FORM
      };
      formConfig.title = {
        text: 'label_admin_info.title',
        actions: <LabelAdminInfoActions onHandleDelete={this.onHandleDelete.bind(this)}/>,
        back: {
          url: this.state.backUrl,
          history: this.props.history,
          location: this.props.location
        }
      }

      return (
          <BsFormPanel size="s">
            <ConfirmationModel
                open={this.state.openConfirmationWindow}
                message="label_admin_info.confirmation_message"
                handleClose={() => this.setState({openConfirmationWindow: false})}
                handleApply={this.onDelete.bind(this)}
            />

            <BsForm
                config={formConfig}
                formData={this.props.currentAdmin}
                disabled={true}/>
          </BsFormPanel>
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = (state) => {
  return {
    currentAdmin: state.label.currentAdmin
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadLabelAdmin: (labelId, userId) => {
      dispatch(loadLabelAdmin(labelId, userId));
    },
    deleteLabelAdmin: (labelId, userId) => {
      dispatch(deleteLabelAdmin(labelId, userId));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GlobalLabelAdminInfo);
